import React, { useState } from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Popover, Tooltip } from '@fiverr-private/fit';
import { CLICKED_ON_ADD_EMOJI_ICON_IN_POPUP_MESSAGE } from '../../../constants/biEvents';
import { useMessage } from '../../../context/contexts/message';
import { useReporting } from '../../../context/contexts/reporting';
import {
    selectFocusFlag,
    useValidationContext
} from '../../../context/contexts/validation';
import MessageControlWrapper from '../MessageControlWrapper';
import Picker from './Picker';

import classes from './style.module.scss';

export const EmojiPicker = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { sendBiEvent, sendMixpanelEvent } = useReporting();
    const { appendToMessage } = useMessage();
    const validationContext = useValidationContext();
    const { focusRef } = selectFocusFlag(validationContext);

    const renderContent = (({ toggle }) => {
        const onSelectEmoji = (event, { emoji }) => {
            const data = { type: CLICKED_ON_ADD_EMOJI_ICON_IN_POPUP_MESSAGE };

            sendBiEvent(data);
            sendMixpanelEvent(data);
            appendToMessage({ value: emoji, separator: ' ' });
            toggle();
            focusRef?.current?.focus();
        };

        return (
            <Picker onEmojiClick={onSelectEmoji}/>
        );
    });

    return (
        <MessageControlWrapper>
            <Popover position={Popover.POSITIONS.TOP_LEFT}
                isOpen={isOpen}
                data-testid="emoji-picker"
                trigger={Popover.TRIGGERS.CLICK}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                content={renderContent}
                containerClassName={classes.emojiPickerContainer}
                className={classes.emojiPicker}>
                <Tooltip containerClassName={classes.tooltip}
                    content={<I18n k="send_message.emoji_picker.tooltip"/>}
                    position={Tooltip.POSITIONS.TOP}>
                    <span className={classNames(classes.pickerIcon, { [classes.isOpen]: isOpen })}/>
                </Tooltip>
            </Popover>
        </MessageControlWrapper>
    );
};

export default EmojiPicker;
